export default "__VITE_ASSET__32a3a781__"